/**
 * 直播间跳转链接
 * @param data
 * @param true_name
 * @returns {string}
 */
export function roomUrl(data,true_name) {

  let params = "user_id=" + data.user_id+ "&roomid=" + data.roomid
    + "&role=" + data.role + "&roomtype=" + data.roomtype+"&roomname=" + data.roomname + "&roomname_en=" + data.roomname_en + "&exhticket_num="
    +data.exhticket_num+ "&truename=" + true_name + "&company=" + data.company + "&company_en=" + data.company_en
      + "&anchorid=" + data.anchorid
      + '&roomLogo=' + data.broadcast_logo;
  let encodeData = window.btoa(window.encodeURIComponent(params));
  return "livestudio.html?"+encodeData
  }


/**
 * 购票跳转链接
 * @param type
 * @param exhibition_id
 * @returns {string}
 */
export function tickUrl(type,exhibition_id) {
  let params = "type=" + type + "&exhibition_id=" + exhibition_id;
  let encodeData = window.btoa(window.encodeURIComponent(params));
  return "tickets.html?"+encodeData;
}

/**
 * 新购票跳转链接
 * @param type
 * @param exhibition_id
 * @returns {string}
 */
export function ticketsRegisterUrl(type,exhibition_id) {
  let params = "type=" + type + "&exhibitionId=" + exhibition_id;
  let encodeData = window.btoa(window.encodeURIComponent(params));
  localStorage.setItem("buyBackUrl", location.href);
  return "ticketsRegister.html?"+encodeData;
}


/**
 * 视频跳转链接加密
 * @param data
 * @returns {string}
 */
export function videoUrl(data) {
  let params = "roomid=" + data.roomid + "&broadcastPlaybackId=" + data.broadcast_playback_id;
  let encodeData = window.btoa(window.encodeURIComponent(params));
  return "playbackVideo.html?"+encodeData;
}

export function windowsGoTo() {
  const https = "https://";
  let protocol = window.location.protocol;
  if (protocol != https) {
    protocol = https;
  }
  const url = protocol + window.location.host +"/haiyun/pc/"
  return '';
}

